// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___Eg7C","fullWidth":"styles_fullWidth__aFMg8","heading":"styles_heading__TNmPq","subheading":"styles_subheading__51Mly"};